import SubscriptionListItem from './SubscriptionListItem';

export default SubscriptionListItem;
